/* eslint-disable @typescript-eslint/naming-convention */
import { ICourierAPIData, ICourierPostAPIResponse, ICourierPostData, ISetCourierResponse } from '../IDataMappings';

const courierMapper = {
  request(info: ICourierPostData): ICourierAPIData {
    const {
      addressId,
      doorId,
      dropoffNotes,
      dropoffDeadlineTime,
      dropoffReadyTime,
      pickupDeadlineTime,
      pickupReadyTime,
    } = info;

    return {
      courier_mode: 'set',
      door_id: doorId,
      dropoff_address_id: addressId,
      dropoff_deadline_dt: dropoffDeadlineTime || '',
      dropoff_notes: dropoffNotes,
      dropoff_ready_dt: dropoffReadyTime || '',
      pickup_deadline_dt: pickupDeadlineTime,
      pickup_ready_dt: pickupReadyTime,
    };
  },
  response(data: ICourierPostAPIResponse): ISetCourierResponse {
    return {
      isAddressUndeliverable: !data.courier_mode_success,
    };
  },
};

export default courierMapper;
